import React from 'react'

import AccountIcon from './svg/ic_person_white_24px.svg'
import RulesIcon from './svg/ic_book_white_24px.svg'
import BackIcon from './svg/ic_arrow_back_white_24px.svg'
import {
  MenuWrapper,
  MenuItem,
  CloseX,
} from '../styles'

const Menu = ({location, auth, goBack, logOut, showRules}) => (
  <MenuWrapper>
    { location.pathname !== '/' ?      <MenuItem onClick={goBack} style={{left: 0, position: 'absolute',}}> <img src={BackIcon}    alt="back" /></MenuItem>   : null }
    { auth ?                           <MenuItem onClick={logOut}>    <img src={AccountIcon} alt="logout" /></MenuItem> : null }
    { location.pathname !== '/rules' ? <MenuItem onClick={showRules}> <img src={RulesIcon}   alt="rules" /></MenuItem>  : null }
  </MenuWrapper>
)

export default Menu



// WEBPACK FOOTER //
// ./src/views/misc/Menu.jsx